<div class="modal-body text-center py-5">
    <p>Which type of Merchant Account would you like to create?</p>
    <button type="button" class="btn btn-uiowa-dark btn-lg me-4" (click)="chooseDefault()">
        Standard MID
    </button>
    <button type="button" class="btn btn-uiowa-dark btn-lg" (click)="chooseCashnet()">
        Cashnet Storefront
    </button>
</div>
